module.exports = __webpack_public_path__ + "static/img/initiative.9a5b599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/initiative.png
// module id = mNUW
// module chunks = 1